import styled from 'styled-components'

import Heading from '../../atoms/Typography/Heading'
import List from '../../atoms/List'
import ListItem from '../../atoms/ListItem'
import Link from '../../atoms/Link/styled'
import Row from '../../atoms/Row'
import Col from '../../atoms/Col'

const Section = styled(Row).attrs({
  as: 'section',
})`
  > ${Heading} {
    flex: 1 1 100%;
    padding: 0 ${props => props.theme.gutter}px;
  }

  h4 {
    color: ${props => props.theme.colors.tertiary};
    font-weight: normal;
    font-size: 1.1em;
  }

  ${Heading} {
    font-weight: 500;
  }

  h2 {
    font-family: ${ props => props.theme.fonts.body };
  }

  ${Col} {
    flex: 1 1 100%;
  }

  ${List} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }

  ${ListItem} {
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
  }

  ${Link} {
    padding: 4px 0;
    color: ${props => props.theme.colors.black};
  }

  @media (min-width: 768px) {
    ${Col} {
      flex: 0 0 33.33%;
      max-width: 33.33%;
    }
    ${Col} + ${Col} {
      flex: 0 0 66.67%;
      max-width: 66.67%;
    }

    ${ListItem} {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }

  @media (min-width: 992px) {
    ${Col} {
      flex: 0 0 20%;
      max-width: 20%;
    }
    ${Col} + ${Col} {
      flex: 0 0 80%;
      max-width: 80%;
    }

    ${ListItem} {
      flex: 0 0 33.33%;
      max-width: 33.33%;
    }
  }
`

export default Section
